import { UploadFile } from "antd";
import { Poster } from "../../../types/Poster";
import { mediaUrl } from "../../../utils/functions/media/mediaUrl";

export function samePosterUrl(
  stored: string | null | undefined,
  uploaded: string | null | undefined
) {
  if (!stored || !uploaded) return false;
  return stored === uploaded || mediaUrl(stored) === uploaded || mediaUrl(stored) === mediaUrl(uploaded);
}

/** A new upload of this aspect replaces the card already in that slot. */
export function replacePoster(
  posters: Poster[] | undefined,
  type: number,
  uploaded: UploadFile | undefined
): Poster[] {
  const current = posters ?? [];
  const previous = [...current].reverse().find((poster) => poster.type === type);
  const response = uploaded?.response as [string, File] | undefined;
  return [
    ...current.filter((poster) => poster.type !== type),
    {
      url: response?.[0] ?? uploaded?.url ?? null,
      file: response?.[1] ?? null,
      type,
      aspectRatio: previous?.aspectRatio,
      id: previous?.id,
    },
  ];
}
